import { getMetadata as p } from "./main6.js";
function y(o, n, t = []) {
  const r = o.resolve(n), { propertyName: e } = p(r, "__QUERY_FN__", {
    propertyName: null
  });
  if (!e)
    throw new Error(`Query Fn function not found for query ${r.name}`);
  return () => Reflect.apply(r[e], r, t);
}
function f(o, n, t = []) {
  const r = o.resolve(n), { propertyName: e } = p(r, "__QUERY_KEY__", {
    propertyName: null
  });
  if (!e)
    throw new Error(`Query Key function not found for query ${r.name}`);
  return Reflect.apply(
    r[e],
    r,
    t
  );
}
export {
  y as queryFn,
  f as queryKey
};
